<div class="main_div">
  <!-- <div class="breadcrumb">
      <span class="setting">Account Settings </span>
      <span> / Password Change</span>
    </div> -->
  <div class="breadcrumb cursor">
    <span
      class="setting"
      [routerLink]="
        isCorporate ? '/corporate/my-profile' : '/employee/my-profile'
      "
      >Account Settings
    </span>
    <span> / Password Change</span>
  </div>
  <div class="title">Change Your Password</div>
  <div class="subtitle">Create a new password to keep your account secure.</div>

  <div class="change_pass_input_parent pb-3">
    <div class="form_div">
      <div>
        <label class="label">Current Password</label>
        <dx-text-box
          class="custom_fill"
          placeholder="Enter your current password"
          [(ngModel)]="changePasswordModel.old_password"
          [mode]="isCurrentPasswordVisible ? 'text' : 'password'"
          (keyup.enter)="onSubmit()"
          [buttons]="[
            {
              name: 'togglePassword',
              location: 'after',
              options: {
                icon: 'eye',
                onClick: toggleCurrentPasswordVisibility,
                elementAttr: {
                  class:
                    'password-toggle ' +
                    (isCurrentPasswordVisible ? 'visible' : '')
                }
              }
            },
            {
              name: 'mail',
              location: 'before',
              options: {
                icon: '../../../../assets/images/icon/lock_icon_black.svg',
                elementAttr: {
                  style: 'border:none'
                }
              }
            }
          ]"
        >
          <dx-validator validationGroup="validationGrp">
            <dxi-validation-rule
              type="required"
              message="Current Password is required"
            >
            </dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
      <div>
        <label class="label">Create New Password</label>
        <dx-text-box
          class="custom_fill"
          placeholder="Enter your new password"
          [(ngModel)]="changePasswordModel.new_password"
          [mode]="isNewPasswordVisible ? 'text' : 'password'"
          (keyup.enter)="onSubmit()"
          [buttons]="[
            {
              name: 'togglePassword',
              location: 'after',
              options: {
                icon: 'eye',
                onClick: toggleNewPasswordVisibility,
                elementAttr: {
                  class:
                    'password-toggle ' + (isNewPasswordVisible ? 'visible' : '')
                }
              }
            },
            {
              name: 'mail',
              location: 'before',
              options: {
                icon: '../../../../assets/images/icon/lock_icon_black.svg',
                elementAttr: {
                  style: 'border:none'
                }
              }
            }
          ]"
        >
          <dx-validator validationGroup="validationGrp">
            <dxi-validation-rule
              type="required"
              message="New Password is required"
            ></dxi-validation-rule>
            <dxi-validation-rule
              type="pattern"
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
              message="Passwords must be at least 8 characters long and contain a mix of upper and lower case letters, numbers, and special characters(@$!%*?&)."
            ></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
      <div>
        <label class="label">Confirm New Password</label>
        <dx-text-box
          class="custom_fill"
          placeholder="Re-enter your new password"
          [mode]="isConfirmPasswordVisible ? 'text' : 'password'"
          (keyup.enter)="onSubmit()"
          [buttons]="[
            {
              name: 'togglePassword',
              location: 'after',
              options: {
                icon: 'eye',
                onClick: toggleConfirmPasswordVisibility,
                elementAttr: {
                  class:
                    'password-toggle ' +
                    (isConfirmPasswordVisible ? 'visible' : '')
                }
              }
            },
            {
              name: 'mail',
              location: 'before',
              options: {
                icon: '../../../../assets/images/icon/lock_icon_black.svg',
                elementAttr: {
                  style: 'border:none'
                }
              }
            }
          ]"
        >
          <dx-validator #targetValidator validationGroup="validationGrp">
            <dxi-validation-rule
              type="required"
              message="Confirm your New Password"
            ></dxi-validation-rule>
            <dxi-validation-rule
              type="compare"
              [comparisonTarget]="passwordComparison"
              message="New Password and Confirm New Password do not match"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
      <button (click)="onSubmit()" class="blue-button-lg w-100 mt-3">
        Change Password
      </button>
      <div class="password_validation">
        <div>Your password must:</div>
        <ul>
          <li>Be at least 8 characters long</li>
          <li>Include both upper and lowercase letters</li>
          <li>Contain at least one number</li>
          <li>
            include at least one special character (e.g., &#64; $ ! % * ? &)
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
